import { Dispatch, FC, ReactNode, SetStateAction } from "react";
import { Stack, Heading, Text, Flex } from "@chakra-ui/react";
import AnalysisFilter from "./AnalysisFilter";

interface AnalysisFilterTemplateProps {
  title: string;
  summary?: string;
  filterChildren?: ReactNode;
  filters?: any;
  dataTable: any[];
  setFilteredTable: (data: any) => void;
  setShowTable: Dispatch<SetStateAction<boolean>>;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  filterRules: Array<() => boolean>;
  setIsLoaded: Dispatch<SetStateAction<boolean>>;
}

const AnalysisFilterTemplate: FC<AnalysisFilterTemplateProps> = ({
  title,
  summary,
  filterChildren,
  filters,
  dataTable,
  setFilteredTable,
  setShowTable,
  setIsSearching,
  filterRules,
  setIsLoaded,
}) => {
  return (
    <Stack spacing={8}>
      <Flex direction="column" gap={4}>
        <Heading as="h2" fontSize="3xl">
          {title}
        </Heading>
        {summary && <Text>{summary}</Text>}
      </Flex>
      <AnalysisFilter
        title="Gerar tabela de indicadores"
        filterChildren={filterChildren}
        filters={filters}
        dataTable={dataTable}
        setFilteredTable={setFilteredTable}
        setShowTable={setShowTable}
        setIsSearching={setIsSearching}
        filterRules={filterRules}
        setIsLoaded={setIsLoaded}
      ></AnalysisFilter>
    </Stack>
  );
};

export default AnalysisFilterTemplate;
